import { render, staticRenderFns } from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=template&id=393b20ae&scoped=true"
import script from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=script&lang=js"
export * from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=script&lang=js"
import style0 from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=style&index=0&id=393b20ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b20ae",
  null
  
)

export default component.exports